import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const InfoTableHead = (props) => {
  const { t } = useTranslation();

  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    {
      id: 'reference',
      label: t('Dashboard.table.head.reference'),
      align: 'left',
    },
    { id: 'createdAt', label: t('Dashboard.table.head.date'), align: 'left' },
    {
      id: 'orderCost.productsCost',
      label: t('Dashboard.table.head.productsTotal'),
      align: 'left',
    },
    {
      id: 'orderCost.commission',
      label: t('Dashboard.table.head.commission'),
      align: 'left',
    },
    {
      id: 'orderCost.tax',
      label: t('Dashboard.table.head.taxes'),
      align: 'left',
    },
    {
      id: 'status.description',
      label: t('Dashboard.table.head.description'),
      align: 'left',
    },
    {
      id: 'productsCount',
      label: t('Dashboard.table.head.quantity'),
      align: 'left',
    },
    { id: 'orderType', label: t('Dashboard.table.head.type'), align: 'left' },
    { id: 'invoice', label: t('Dashboard.table.head.invoice'), align: 'right' },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding="center"
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              disabled={true}>
              <strong>{headCell.label}</strong>
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

InfoTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
